import React, {Component} from "react";
import { Link, Navigate } from "react-router-dom";
import withRouter from '../actionHooks/withRouter';
import axiosBaseURL from "../httpCommon";

class EventDetails extends Component {
    constructor(props) {
        super(props);
        this.state={
            localEvent: "",
            isCompleted: false,
            errMsg: [],
            msg: "",

            loading: false,
            
            name: "",
            address: "",
            mobile: "",
            notes: "",

            loggedIn: window.localStorage.getItem("isLoggedIn"),
            authUser: JSON.parse(window.localStorage.getItem("userData"))
        }
    }

    changeHandler=(event)=>{
        this.setState({
            [event.target.name]:event.target.value
        })
    }

    async componentDidMount() {
          await this.fetchEventDetails();
    }

    async fetchEventDetails(){
        await axiosBaseURL.get('api/v1/event/' + this.props.params.event_id, {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.state.authUser.token
            }
        })
            .then(response => {
                if(response.data.status === 200) {
                    this.setState({
                        localEvent: response.data.localEvent,
                        errMsg: "",
                    })
                }
                if(response.data.status === 404) {
                    this.setState({
                        localEvent: "",
                        errMsg: response.data.msg
                    })
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    submitHandler=()=>{
        this.setState({
            loading: true
        })
        axiosBaseURL.post('api/v1/createCustomer', {
            local_event_id: this.state.localEvent.id,
            name: this.state.name,
            address: this.state.address,
            mobile: this.state.mobile !== "" ? '+91' + this.state.mobile : null,
            notes: this.state.notes
        },{
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.state.authUser.token
            }
        })
            .then(response => {
                if(response.data.status === 200){
                    this.setState({
                        msg: "",
                        loading: false,
                        isCompleted: true,
                        
                        name: "",
                        address: "",
                        mobile: "",
                        notes: ""
                    })
                }
                if(response.data.status === "404"){
                    this.setState({
                        msg: response.data.msg,
                        loading: false,
                        isCompleted: false
                    })
                }
                if(response.data.status === "failed"){
                    this.setState({
                        errMsg: response.data.validation_error,
                        loading: false,
                        isCompleted: false
                    })
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    render (){
        const localEvent = this.state.localEvent

        const {loading} = this.state

        return(
            <>
            <header>
        <div className="back-links">
            <Link to={"/events"}>
                <i className="iconly-Arrow-Left icli"></i>
                <div className="content">
                    <h2>{localEvent.title}</h2>
                </div>
            </Link>
        </div>
    </header>
    
    
    
    {this.state.isCompleted === true ? 
                    (<>
                        <div className="contentDiv mt-5">
                            <div style={{textAlign: "center"}}>
                                <img src="/success.gif" width="50%" height="auto"/>
                                <h2>Successfully Saved</h2>
                            </div>
                            <div style={{textAlign: "center", marginTop: "15px"}}>
                                <button className="btn btn-solid col-7 text-uppercase" onClick={()=>this.setState({isCompleted: false})}>
                                    Submit More <i className="iconly-Arrow-Right icli"></i>
                                </button>
                            </div>
                        </div>
                    </>)
                    :
                    (<>
                    <section className="user-avtar-section top-space pt-0 px-15">
        <img src={localEvent.event_picture} className="img-fluid" alt=""/>
    </section>
                    <form>
    <section className="detail-form-section px-15">
        <span className="text-danger py-3">{this.state.msg}</span>
        <h2 className="page-title mb-4">Add New Entry</h2>

            <div className="form-floating mb-4">
                <input className="form-control" type="text" name="name" id="name" placeholder="ex. Prokash Roy" value={this.state.name} onChange={this.changeHandler}/>
                <label htmlFor="name">Name:</label>
                <span className="text-danger">{this.state.errMsg.name}</span>
            </div>

            <div className="form-floating mb-4">
                <input className="form-control" type="text" name="address"
                                                   id="address" placeholder="ex. 22/N Jessore Road, Habra West Bengal 743263"
                                                   value={this.state.address}
                                                   onChange={this.changeHandler}/>
                <label htmlFor="address">Address:</label>
                <span className="text-danger">{this.state.errMsg.address}</span>
                                    
            </div>
            
            <div className="form-floating mb-4">
                <input className="form-control" type="text" name="mobile"
                                                   id="mobile" placeholder="ex. 8013546571"
                                                   value={this.state.mobile}
                                                   onChange={this.changeHandler} maxLength="10"/>
                <label htmlFor="mobile">10 Digit Mobile:</label>
                                    <span className="text-danger">{this.state.errMsg.mobile}</span>
            </div>

            <div className="form-floating mb-4">
                <input className="form-control" type="text" name="notes"
                                                   id="notes" placeholder="Enter any notes"
                                                   value={this.state.notes}
                                                   onChange={this.changeHandler}/>
                <label htmlFor="notes">Notes (Optional):</label>
                <span className="text-danger">{this.state.errMsg.notes}</span>                                    
            </div>

        
    </section>
    <div className="divider"></div>

   
    <section className="panel-space"></section>


    <div className="cart-bottom row m-0">
        <div>
            <div className="left-content col-5">
                <Link to="/events" className="title-color">CANCEL</Link>
            </div>
            
            <button className="btn btn-solid col-7 text-uppercase" type="submit" onClick={this.submitHandler}
                                                disabled={loading}>
                                            {loading && (
                                                <img src={"/" + "static/images/loader.gif"} width="20"
                                                     height="20" className="mr-3"/>)}
                                            {loading && <>Processing..</>}
                                            {!loading && <>Submit Data</>}
                                        </button>
        </div>
    </div>
    </form>
</>)
    }
            </>
        );
    }
}

export default withRouter(EventDetails);